import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Container, Grid } from "@mui/material";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import Fetching from "../../../Common/Fetching";
import QuestionnaireListItem from "./QuestionnaireListItem";

import { DataTypes } from "../../../../constants";
import msfActions from "../../../../actions/msfActions";
import { getQuestionnaires, isFetching } from "../../../../reducers";


const QuestionnaireList = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(msfActions.getQuestionnaires('P-MSF'));
    }, [dispatch]);

    const questionnaires = useSelector(getQuestionnaires);
    const fetching = useSelector((state) => isFetching(state, DataTypes.MSF_QUESTIONNAIRE));

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12} >
                    <BreadcrumbBuilder />
                </Grid>
                {fetching && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}
                {!!questionnaires && questionnaires.map((data) => (
                    <Grid item xs={12} key={data.uuid}>
                        <QuestionnaireListItem data={data}/>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default QuestionnaireList;
